import { Drawer as AntdDrawer, Flex } from 'antd';
import styled from 'styled-components';

import { NeutralColors } from '@/theme';

export const Drawer = styled(AntdDrawer)`
  & .panorama-drawer-header {
    padding: 12px 12px;
  }

  & .panorama-drawer-body,
  & .panorama-drawer-footer {
    padding: 0;
  }
`;

export const FullHeightContainer = styled(Flex)`
  height: 100%;
`;

export const Body = styled(Flex)`
  overflow-y: auto;
  padding: 16px 18px;
  margin-bottom: 60px;
`;

export const FooterWrapper = styled(Flex)`
  justify-content: space-between;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 12px 20px;
  margin: 0 -18px;
  box-shadow: 0px -5px 5px 1px rgba(0, 0, 0, 0.07);
  background: ${NeutralColors[0]};
`;
